import GiftAmountSelect from './gift-amount-select'

export default GiftAmountSelect
